// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "66e2ef6fb13d944e7ef5" + ".chunk.js";
};